import styled from 'styled-components'
import { Link } from '@navent-jobs/ui-kit/components/link'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

export const ChipContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: flex-start;
  margin: 0px 0px 16px 0px;
  gap: 16px 8px;
  flex-wrap: wrap;
`

export const DateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const InformationItem = styled.li`
  display: flex;
  align-items: center;
  align-content: flex-start;
  padding: 0px;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey48};
  text-decoration: none;
  word-break: break-word;
  margin: 0px 0px 16px 0px;

  &:last-child {
    margin-bottom: 0px;
  }
`

export const LinkItem = styled(Link)`
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey48};
  padding: 0 0 0 28px;
  text-align: left;
  &:hover {
    color: ${({ theme }) => theme.colors.grey48};
  }

  i {
    left: 0;
    width: 20px;
    height: 20px;

    &:before {
      width: 20px;
      height: 20px;
    }
  }
`

export const InformationlIcon = styled(Icon)`
  display: flex;
  align-self: center;
  margin: 0px 8px 0px 0px;
`

export const InfoLabel = styled('h2')`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey48};
`

export const AvisoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px 24px;
  flex-wrap: wrap;
`
